export type StatusTone = 'danger' | 'info' | 'warning' | 'neutral'

export type StatusCondition =
  | { kind: 'syncing'; tone: 'info'; total: number; done: number }
  | { kind: 'offline'; tone: 'warning'; pendingCount: number; returnTo: { date: string; shift: string } | null }
  | { kind: 'syncIssues'; tone: 'danger'; count: number }
  | { kind: 'pending'; tone: 'info'; count: number }
  | { kind: 'shiftLocked'; tone: 'neutral'; dateIso: string; shift: string; exists: boolean; canUnlock: boolean }

export interface StatusBannerInputs {
  isOnline: boolean
  isSyncing: boolean
  syncTotal: number
  syncDone: number
  pendingCount: number
  syncIssueCount: number
  isShiftPage: boolean
  isShiftLocked: boolean
  shiftExists: boolean
  canToggleLock: boolean
  selectedDate: string
  selectedShift: string
  provisionalShiftDate: string | null
  provisionalShift: string | null
}

export function resolveStatusConditions(input: StatusBannerInputs): StatusCondition[] {
  const conditions: StatusCondition[] = []

  if (input.isSyncing) {
    conditions.push({ kind: 'syncing', tone: 'info', total: input.syncTotal, done: input.syncDone })
  }

  if (!input.isOnline) {
    const isOnProvisionalShift = input.provisionalShiftDate === input.selectedDate
      && input.provisionalShift === input.selectedShift
    const returnTo = input.provisionalShiftDate && input.provisionalShift && !isOnProvisionalShift
      ? { date: input.provisionalShiftDate, shift: input.provisionalShift }
      : null

    conditions.push({ kind: 'offline', tone: 'warning', pendingCount: input.pendingCount, returnTo })
  }

  if (input.syncIssueCount > 0) {
    conditions.push({ kind: 'syncIssues', tone: 'danger', count: input.syncIssueCount })
  }

  if (input.isOnline && !input.isSyncing && input.pendingCount > 0) {
    conditions.push({ kind: 'pending', tone: 'info', count: input.pendingCount })
  }

  if (input.isShiftPage && input.isShiftLocked) {
    conditions.push({
      kind: 'shiftLocked',
      tone: 'neutral',
      dateIso: input.selectedDate,
      shift: input.selectedShift,
      exists: input.shiftExists,
      canUnlock: input.isOnline && input.shiftExists && input.canToggleLock,
    })
  }

  return conditions
}
